import React, { Component } from "react";
import { Router, Route, Switch, HashRouter } from "react-router-dom";
import browserHistory from "./BrowserHistory";
import Home from "./components/Home";
import Teams from "./components/Teams";
import Fixtures from "./components/Fixtures";
import History from "./components/layouts/OurHistory";
import HistoryExtended from "./components/layouts/HistoryExtended";
import FineAnnoNews from "./components/FineAnnoNews";
import NewsPage from "./components/layouts/NewsPage";
import SafeguardingPage from "./components/layouts/SafeguardingPage";

class Routes extends Component {
    render() {
        return (
            <Router history={browserHistory}>
                <HashRouter basename="/">
                    <Switch>
                        <Route exact path={'/'} render={(props) => (<Home {...props} />)} />
                        <Route exact path={'/home'} render={(props) => (<Home {...props} />)} />
                        <Route exact path={'/teams'} render={(props) => (<Teams {...props} />)} />
                        <Route exact path={'/fixtures'} render={(props) => (<Fixtures {...props} />)} />
                        <Route exact path={'/news/5'} render={(props) => (<FineAnnoNews {...props} />)} />
                        <Route exact path={'/history'} render={(props) => (<History {...props} />)} />
                        <Route exact path={'/history_extended'} render={(props) => (<HistoryExtended {...props} />)} />
                        <Route exact path={'/news'} render={(props) => (<NewsPage {...props} />)} />
                        <Route exact path={'/safeguarding'} render={(props) => (<SafeguardingPage {...props} />)} />
                    </Switch>
                </HashRouter>
            </Router>
        )
    }
}

export default Routes;